/******/ (() => { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./node_modules/@shopify/theme-predictive-search/src/request.js":
/*!**********************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/request.js ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ request)
/* harmony export */ });
/* harmony import */ var _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utilities/CustomError */ "./node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js");


function request(searchPath, configParams, query, onSuccess, onError) {
  var xhr = new XMLHttpRequest();
  var route = searchPath + '/suggest.json';

  xhr.onreadystatechange = function () {
    if (xhr.readyState === XMLHttpRequest.DONE) {
      var contentType = xhr.getResponseHeader("Content-Type");

      if (xhr.status >= 500) {
        onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.ServerError());

        return;
      }

      if (xhr.status === 404) {
        onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.NotFoundError(xhr.status));

        return;
      }

      if (
        typeof contentType !== "string" ||
        contentType.toLowerCase().match("application/json") === null
      ) {
        onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.ContentTypeError(xhr.status));

        return;
      }

      if (xhr.status === 417) {
        try {
          var invalidParameterJson = JSON.parse(xhr.responseText);

          onError(
            new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.InvalidParameterError(
              xhr.status,
              invalidParameterJson.message,
              invalidParameterJson.description
            )
          );
        } catch (error) {
          onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 422) {
        try {
          var expectationFailedJson = JSON.parse(xhr.responseText);

          onError(
            new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.ExpectationFailedError(
              xhr.status,
              expectationFailedJson.message,
              expectationFailedJson.description
            )
          );
        } catch (error) {
          onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 429) {
        try {
          var throttledJson = JSON.parse(xhr.responseText);

          onError(
            new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.ThrottledError(
              xhr.status,
              throttledJson.message,
              throttledJson.description,
              xhr.getResponseHeader("Retry-After")
            )
          );
        } catch (error) {
          onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.JsonParseError(xhr.status));
        }

        return;
      }

      if (xhr.status === 200) {
        try {
          var res = JSON.parse(xhr.responseText);
          res.query = query;
          onSuccess(res);
        } catch (error) {
          onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.JsonParseError(xhr.status));
        }

        return;
      }

      try {
        var genericErrorJson = JSON.parse(xhr.responseText);
        onError(
          new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.GenericError(
            xhr.status,
            genericErrorJson.message,
            genericErrorJson.description
          )
        );
      } catch (error) {
        onError(new _utilities_CustomError__WEBPACK_IMPORTED_MODULE_0__.JsonParseError(xhr.status));
      }

      return;
    }
  };

  xhr.open(
    "get",
    route + "?q=" + encodeURIComponent(query) + "&" + configParams
  );

  xhr.setRequestHeader("Content-Type", "application/json");

  xhr.send();
}

/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js":
/*!**************************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js ***!
  \**************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ PredictiveSearch)
/* harmony export */ });
/* harmony import */ var _validate__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./validate */ "./node_modules/@shopify/theme-predictive-search/src/validate.js");
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./request */ "./node_modules/@shopify/theme-predictive-search/src/request.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utilities */ "./node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utilities */ "./node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utilities */ "./node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js");
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utilities */ "./node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js");




var DEBOUNCE_RATE = 10;
var requestDebounced = (0,_utilities__WEBPACK_IMPORTED_MODULE_0__["default"])(_request__WEBPACK_IMPORTED_MODULE_1__["default"], DEBOUNCE_RATE);

function PredictiveSearch(config) {
  if (!config) {
    throw new TypeError("No config object was specified");
  }

  var configParameters = config;

  this._retryAfter = null;
  this._currentQuery = null;

  this.dispatcher = new _utilities__WEBPACK_IMPORTED_MODULE_2__["default"]();
  this.cache = new _utilities__WEBPACK_IMPORTED_MODULE_3__["default"]({ bucketSize: 40 });

  this.searchPath = configParameters.search_path || "/search";

  if(configParameters.search_path) {
    delete configParameters['search_path'];
  }

  this.configParams = (0,_utilities__WEBPACK_IMPORTED_MODULE_4__["default"])(configParameters);
}

PredictiveSearch.SEARCH_PATH = "/search";

PredictiveSearch.TYPES = {
  PRODUCT: "product",
  PAGE: "page",
  ARTICLE: "article",
  COLLECTION: "collection"
};

PredictiveSearch.FIELDS = {
  AUTHOR: "author",
  BODY: "body",
  PRODUCT_TYPE: "product_type",
  TAG: "tag",
  TITLE: "title",
  VARIANTS_BARCODE: "variants.barcode",
  VARIANTS_SKU: "variants.sku",
  VARIANTS_TITLE: "variants.title",
  VENDOR: "vendor"
};

PredictiveSearch.UNAVAILABLE_PRODUCTS = {
  SHOW: "show",
  HIDE: "hide",
  LAST: "last"
};

PredictiveSearch.prototype.query = function query(query) {
  try {
    (0,_validate__WEBPACK_IMPORTED_MODULE_5__.validateQuery)(query);
  } catch (error) {
    this.dispatcher.dispatch("error", error);
    return;
  }

  if (query === "") {
    return this;
  }

  this._currentQuery = normalizeQuery(query);
  var cacheResult = this.cache.get(this._currentQuery);
  if (cacheResult) {
    this.dispatcher.dispatch("success", cacheResult);
    return this;
  }

  requestDebounced(
    this.searchPath,
    this.configParams,
    query,
    function(result) {
      this.cache.set(normalizeQuery(result.query), result);
      if (normalizeQuery(result.query) === this._currentQuery) {
        this._retryAfter = null;
        this.dispatcher.dispatch("success", result);
      }
    }.bind(this),
    function(error) {
      if (error.retryAfter) {
        this._retryAfter = error.retryAfter;
      }
      this.dispatcher.dispatch("error", error);
    }.bind(this)
  );

  return this;
};

PredictiveSearch.prototype.on = function on(eventName, callback) {
  this.dispatcher.on(eventName, callback);

  return this;
};

PredictiveSearch.prototype.off = function on(eventName, callback) {
  this.dispatcher.off(eventName, callback);

  return this;
};

function normalizeQuery(query) {
  if (typeof query !== "string") {
    return null;
  }

  return query
    .trim()
    .replace(" ", "-")
    .toLowerCase();
}


/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js":
/*!******************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/utilities/Cache.js ***!
  \******************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Cache)
/* harmony export */ });
function Cache(config) {
  this._store = {};
  this._keys = [];
  if (config && config.bucketSize) {
    this.bucketSize = config.bucketSize;
  } else {
    this.bucketSize = 20;
  }
}

Cache.prototype.set = function(key, value) {
  if (this.count() >= this.bucketSize) {
    var deleteKey = this._keys.splice(0, 1);
    this.delete(deleteKey);
  }

  this._keys.push(key);
  this._store[key] = value;

  return this._store;
};

Cache.prototype.get = function(key) {
  return this._store[key];
};

Cache.prototype.has = function(key) {
  return Boolean(this._store[key]);
};

Cache.prototype.count = function() {
  return Object.keys(this._store).length;
};

Cache.prototype.delete = function(key) {
  var exists = Boolean(this._store[key]);
  delete this._store[key];
  return exists && !this._store[key];
};


/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js":
/*!************************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/utilities/CustomError.js ***!
  \************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ContentTypeError: () => (/* binding */ ContentTypeError),
/* harmony export */   ExpectationFailedError: () => (/* binding */ ExpectationFailedError),
/* harmony export */   GenericError: () => (/* binding */ GenericError),
/* harmony export */   InvalidParameterError: () => (/* binding */ InvalidParameterError),
/* harmony export */   JsonParseError: () => (/* binding */ JsonParseError),
/* harmony export */   NotFoundError: () => (/* binding */ NotFoundError),
/* harmony export */   ServerError: () => (/* binding */ ServerError),
/* harmony export */   ThrottledError: () => (/* binding */ ThrottledError)
/* harmony export */ });
function GenericError() {
  var error = Error.call(this);

  error.name = "Server error";
  error.message = "Something went wrong on the server";
  error.status = 500;

  return error;
}

function NotFoundError(status) {
  var error = Error.call(this);

  error.name = "Not found";
  error.message = "Not found";
  error.status = status;

  return error;
}

function ServerError() {
  var error = Error.call(this);

  error.name = "Server error";
  error.message = "Something went wrong on the server";
  error.status = 500;

  return error;
}

function ContentTypeError(status) {
  var error = Error.call(this);

  error.name = "Content-Type error";
  error.message = "Content-Type was not provided or is of wrong type";
  error.status = status;

  return error;
}

function JsonParseError(status) {
  var error = Error.call(this);

  error.name = "JSON parse error";
  error.message = "JSON syntax error";
  error.status = status;

  return error;
}

function ThrottledError(status, name, message, retryAfter) {
  var error = Error.call(this);

  error.name = name;
  error.message = message;
  error.status = status;
  error.retryAfter = retryAfter;

  return error;
}

function InvalidParameterError(status, name, message) {
  var error = Error.call(this);

  error.name = name;
  error.message = message;
  error.status = status;

  return error;
}

function ExpectationFailedError(status, name, message) {
  var error = Error.call(this);

  error.name = name;
  error.message = message;
  error.status = status;

  return error;
}


/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js":
/*!***********************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/utilities/Dispatcher.js ***!
  \***********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ Dispatcher)
/* harmony export */ });
function Dispatcher() {
  this.events = {};
}

Dispatcher.prototype.on = function(eventName, callback) {
  var event = this.events[eventName];
  if (!event) {
    event = new DispatcherEvent(eventName);
    this.events[eventName] = event;
  }
  event.registerCallback(callback);
};

Dispatcher.prototype.off = function(eventName, callback) {
  var event = this.events[eventName];
  if (event && event.callbacks.indexOf(callback) > -1) {
    event.unregisterCallback(callback);
    if (event.callbacks.length === 0) {
      delete this.events[eventName];
    }
  }
};

Dispatcher.prototype.dispatch = function(eventName, payload) {
  var event = this.events[eventName];
  if (event) {
    event.fire(payload);
  }
};

function DispatcherEvent(eventName) {
  this.eventName = eventName;
  this.callbacks = [];
}

DispatcherEvent.prototype.registerCallback = function(callback) {
  this.callbacks.push(callback);
};

DispatcherEvent.prototype.unregisterCallback = function(callback) {
  var index = this.callbacks.indexOf(callback);
  if (index > -1) {
    this.callbacks.splice(index, 1);
  }
};

DispatcherEvent.prototype.fire = function(payload) {
  var callbacks = this.callbacks.slice(0);
  callbacks.forEach(function(callback) {
    callback(payload);
  });
};


/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js":
/*!*********************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/utilities/debounce.js ***!
  \*********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ debounce)
/* harmony export */ });
function debounce(func, wait) {
  var timeout = null;
  return function() {
    var context = this;
    var args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(function() {
      timeout = null;
      func.apply(context, args);
    }, wait || 0);
  };
}


/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js":
/*!********************************************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/utilities/objectToQueryParams.js ***!
  \********************************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (/* binding */ objectToQueryParams)
/* harmony export */ });
function objectToQueryParams(obj, parentKey) {
  var output = "";
  parentKey = parentKey || null;

  Object.keys(obj).forEach(function (key) {
    var outputKey = key + "=";
    if (parentKey) {
      outputKey = parentKey + "[" + key + "]";
    }

    switch (trueTypeOf(obj[key])) {
      case "object":
        output += objectToQueryParams(obj[key], parentKey ? outputKey : key);
        break;
      case "array":
        output += outputKey + "=" + obj[key].join(",") + "&";
        break;
      default:
        if (parentKey) {
          outputKey += "=";
        }
        output += outputKey + encodeURIComponent(obj[key]) + "&";
        break;
    }
  });

  return output;
}

function trueTypeOf(obj) {
  return Object.prototype.toString
    .call(obj)
    .slice(8, -1)
    .toLowerCase();
}

/***/ }),

/***/ "./node_modules/@shopify/theme-predictive-search/src/validate.js":
/*!***********************************************************************!*\
  !*** ./node_modules/@shopify/theme-predictive-search/src/validate.js ***!
  \***********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   validateQuery: () => (/* binding */ validateQuery)
/* harmony export */ });
function validateQuery(query) {
  var error;

  if (query === null || query === undefined) {
    error = new TypeError("'query' is missing");
    error.type = "argument";
    throw error;
  }

  if (typeof query !== "string") {
    error = new TypeError("'query' is not a string");
    error.type = "argument";
    throw error;
  }
}


/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
/*!*************************************!*\
  !*** ./src/js/predictive-search.js ***!
  \*************************************/
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @shopify/theme-predictive-search */ "./node_modules/@shopify/theme-predictive-search/src/theme-predictive-search.js");

var elements = {};
var clearParent = function clearParent(parent) {
  while (parent.firstChild) {
    parent.removeChild(parent.lastChild);
  }
};
var createProductElement = function createProductElement(product) {
  var productEl = document.createElement("div");
  productEl.classList.add("predictive-search__product");
  var imageContainer = document.createElement("div");
  imageContainer.classList.add("predictive-search__product-image");
  var image = document.createElement("img");
  image.setAttribute("src", product.featured_image.url);
  image.setAttribute("alt", product.featured_image.alt);
  imageContainer.appendChild(image);
  var title = document.createElement("h2");
  title.classList.add("predictive-search__product-title");
  title.appendChild(document.createTextNode(product.title));
  var link = document.createElement("a");
  link.setAttribute("href", product.url);
  var linkText = document.createElement("span");
  linkText.classList.add("sr-only");
  linkText.appendChild(document.createTextNode(product.title));
  link.appendChild(linkText);
  var price = document.createElement("span");
  price.classList.add("predictive-search__product-price");
  price.appendChild(document.createTextNode("".concat(window.Shopify.currencySymbol + product.price)));
  productEl.appendChild(link);
  productEl.appendChild(imageContainer);
  productEl.appendChild(title);
  productEl.appendChild(price);
  return productEl;
};
var setElements = function setElements() {
  elements.search = document.querySelector("[data-search-bar]");
  elements.predictive = document.querySelector("[data-predictive-search]");
  elements.no_results = document.querySelector("[data-no-results]");
};
var init = function init() {
  setElements();
  if (!elements.search || !elements.predictive) return;
  var predictiveSearch = new _shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"]({
    search_path: _shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"].SEARCH_PATH,
    resources: {
      type: [_shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"].TYPES.PRODUCT],
      limit: 10,
      options: {
        unavailable_products: "last",
        fields: [_shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"].FIELDS.TITLE, _shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"].FIELDS.PRODUCT_TYPE, _shopify_theme_predictive_search__WEBPACK_IMPORTED_MODULE_0__["default"].FIELDS.VARIANTS_TITLE]
      }
    }
  });
  predictiveSearch.on("success", function (json) {
    clearParent(elements.predictive);
    elements.no_results.classList.remove("is-showing");
    if (!json.resources.results.products.length) {
      elements.no_results.classList.add("is-showing");
      return;
    }
    json.resources.results.products.forEach(function (product) {
      elements.predictive.appendChild(createProductElement(product));
    });
    elements.predictive.classList.add("is-showing");
  });
  predictiveSearch.on("error", function (error) {
    elements.predictive.classList.remove("is-showing");
    console.error(error, "Error");
  });
  elements.search.addEventListener("keyup", function () {
    if (!elements.search.value.length) {
      elements.predictive.classList.remove("is-showing");
    }
    predictiveSearch.query(elements.search.value);
  });
};
init();
/******/ })()
;